import { EuiButtonIcon, EuiHorizontalRule, EuiText, htmlIdGenerator } from '@elastic/eui';
import React from 'react';

export const OrderRating = ({ data, order }) => {
    return (
        <div key={htmlIdGenerator()()} style={{ paddingLeft: '3px' }}>
            <EuiText size='xs'>
                <h4>Order Feedback</h4>
            </EuiText>
            {(data.isPast || data.isCustomerOrder) && order.feedback !== null ? (
                <>
                    {[1, 2, 3, 4, 5].map((star) => (
                        <EuiButtonIcon
                            aria-label='starEmpty'
                            key={star}
                            iconType={order.feedback.star >= star ? 'starFilled' : 'starEmpty'}
                            color='warning'
                            iconSize='l'
                        />
                    ))}
                    {order.feedback.comment !== null && <EuiText size='xs'>{order.feedback.comment}</EuiText>}
                </>
            ) : (
                <EuiText size='xs'>Rating not given!</EuiText>
            )}
            {(data.isPast || data.isCustomerOrder) && <EuiHorizontalRule margin='s' />}
        </div>
    );
};
